/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type ErrorGroupListSeverity =
  (typeof ErrorGroupListSeverity)[keyof typeof ErrorGroupListSeverity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorGroupListSeverity = {
  critical: "critical",
  error: "error",
  warning: "warning",
} as const;
